import { getScreenWidth } from 'emrn-design/getScreenWidth';
import { isIPad } from 'emrn-design/isIPad';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { View, Text, StyleSheet, Image, Animated, LayoutChangeEvent, Easing } from 'react-native';

const ScreenWidth = getScreenWidth();
interface NoticeProps {
  textStr: string;
}
interface NoticeState {
  translateX: Animated.Value;
  translateX2: Animated.Value;
  view2Left: number;
}

export class Notice extends Component<NoticeProps, NoticeState> {
  private width = 0;
  private animations: Animated.CompositeAnimation | null = null;
  constructor(props: NoticeProps) {
    super(props);
    this.state = {
      translateX: new Animated.Value(0),
      translateX2: new Animated.Value(0),
      view2Left: 0,
    };
  }
  componentWillUnmount = () => {
    this.animations && this.animations.reset();
  };
  onLayout = (event: LayoutChangeEvent) => {
    if (event.nativeEvent.layout.width >= this.width) {
      this.width = event.nativeEvent.layout.width;

      //超出一屏，需要跑马
      this.setState(
        {
          view2Left: this.width,
        },
        () => {
          setTimeout(() => {
            this.animationsStart();
          }, 300);
        }
      );
    }
  };

  animationsStart = () => {
    let { translateX, translateX2 } = this.state;
    let { textStr = '' } = this.props;
    let duraction = textStr.length * 250;
    this.animations = Animated.parallel([
      Animated.timing(translateX, {
        // tension: 10,
        easing: Easing.linear,
        duration: duraction,
        useNativeDriver: false,
        toValue: -this.width,
      }),
      Animated.timing(translateX2, {
        // tension: 10,
        easing: Easing.linear,
        duration: duraction,
        useNativeDriver: false,
        toValue: -this.width,
      }),
    ]);
    this.animations.start(() => {
      // this.setState({
      //     translateX: new Animated.Value(0),
      //     translateX2: new Animated.Value(0)
      // })

      Animated.timing(translateX, {
        easing: Easing.linear,
        delay: 0,
        duration: 0,
        useNativeDriver: false,
        toValue: 0,
      }).start();
      Animated.timing(translateX2, {
        easing: Easing.linear,
        delay: 0,
        duration: 0,
        useNativeDriver: false,
        toValue: 0,
      }).start();
      this.animationsStart();
    });
  };

  render() {
    let { translateX, translateX2, view2Left } = this.state;
    let { textStr } = this.props;
    return (
      <>
        {textStr ? (
          <View style={styles.container}>
            <View style={styles.section}>
              <Animated.View onLayout={this.onLayout} style={[styles.content, { transform: [{ translateX }] }]}>
                <Text style={styles.content_text} numberOfLines={1}>
                  {textStr}
                </Text>
              </Animated.View>
              <Animated.View style={[styles.content, { transform: [{ translateX: translateX2 }], left: view2Left }]}>
                <Text style={styles.content_text} numberOfLines={1}>
                  {textStr}
                </Text>
              </Animated.View>
            </View>
          </View>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: rpx(25),
    borderRadius: rpx(17.5),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  section: {
    marginRight: rpx(15),
    height: rpx(17.5),
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    overflow: 'hidden',
  },
  content: {
    flexDirection: 'row',
    position: 'absolute',
  },
  content_text: {
    fontSize: isIPad ? rpx(18) : rpx(12),
    lineHeight: isIPad ? rpx(20) : rpx(16),
    color: '#fff',
  },
});
